
export class CardModel{
    holderName: string;
    email: string;
    cardNumber: number;
    telephone: string;
    expirationMonth: number;
    expirationYear: number;
    cvv2: number;

    constructor(){}
}